<template>
  <div class="flex items-center">
    <div v-if="params.data.photoUrl != ''">
      <vs-avatar
        :src="params.data.photoUrl"
        class="flex-shrink-0 mr-2"
        size="30px"
        @click="navigateToUrl"
      />
    </div>
    <div v-else>
      <vs-avatar
        class="rounded-full shadow-md cursor-pointer block"
        size="40"
        :text="params.data.name"
        :color="getColor()"
      />
    </div>
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    >
      {{ params.value }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "CellRendererLink",
  computed: {
    url() {
      if (this.params && this.params.data && this.params.data.tenantsId) {
        const url = `/admin/companyinformation/${this.params.data.tenantsId}`;
        console.log("URL:", url); // Debugging output
        console.log("Data:", this.params.data); // Debugging output
        return url;
      } else {
        console.warn("Tenants ID is not available.");
        return ""; // Return an empty string or a fallback URL
      }
    },
    color1() {
      return this.params.data.name.length;
    },
  },

  methods: {
    navigateToUrl() {
      console.log("Navigating to URL:", this.url); // Debugging output
      this.$router.push(this.url);
    },
    getColor() {
      const length = this.params.data.name.length;
      return length < 12
        ? "success"
        : length <= 15
        ? "primary"
        : length <= 20
        ? "warning"
        : "danger";
    },
  },
};
</script>
